document.addEventListener("DOMContentLoaded", async function() {

  const viewportWidth = window.innerWidth;

  const headings = document.querySelectorAll('.footer-block__heading');
  const blocks = document.querySelectorAll('.footer-block:not(:first-child)');
  console.log({blocks})
  if (viewportWidth <= 750) {
    headings.forEach((heading) => {
      heading.insertAdjacentHTML('beforeend', `
      <span class="footer-arrow-icon">
        <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="#5f6368"
              >
                <path
                  d="m480-522.35-181 181L238.35-401 480-642.65 721.65-401 661-341.35l-181-181Z"
                />
              </svg>
      </span>
    `);
    })

    blocks.forEach((block) => {
      block.addEventListener('click', () => {

        if (block.classList.contains('active')) {
          block.classList.remove('active');
          block.querySelector('.footer-block__details-content').style.display = 'none';
        } else {
           blocks.forEach(b => {
            b.classList.remove('active');
            b.querySelector('.footer-block__details-content').style.display = 'none';
          });
          block.classList.add('active');
          block.querySelector('.footer-block__details-content').style.display = 'block';
        }
        


      })
    })
  }

})